module.exports = __webpack_public_path__ + "assets/img/badge_instant.99890e06.svg";